import { FrameWorkFormatDate, FrameWorkHideAlert, FrameWorkMessageErrorAlert, FrameWorkSimpleMessageState, OrdenExpressNavegatePath, OrdenExpressValidateSecurity } from 'orden_express/frameWork/frameWork.js';
import { setDateReportsRequested, setfFilterRouteReportProducts, setMessageReportsRequested } from 'orden_express/reports/reportsActions.js';
import { requestGetReportDashboard } from 'orden_express/reports/reportsEpic.js';
import { requestGetRoutes } from 'orden_express/routes/routesEpic.js';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import ReactDatetime from 'react-datetime';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Button, Card, CardBody, CardFooter, CardHeader, CardTitle, Col, FormGroup, Row } from 'reactstrap';
import { bindActionCreators } from 'redux';


class DashboardOrdenExpress extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            alert: '',
            dateStart: new Date(),
            dateEnd: new Date(),
        }
        OrdenExpressValidateSecurity(this);
        this.props.requestGetRoutes();
        this.lookingForResults(this.state.dateStart, this.state.dateEnd, this.props.reportsReducerState.filterRouteReportProducts.value);
    }

    componentDidUpdate(prevProps) {
        if (this.props.reportsReducerState.messageReportsRequested !== prevProps.reportsReducerState.messageReportsRequested) {
            this.processMessageState(this.props.reportsReducerState.messageReportsRequested);
        }
    }

    changeSelectRouteFilter = (pData) => {
        this.props.setfFilterRouteReportProducts(pData)
        this.lookingForResults(this.state.dateStart, this.state.dateEnd, pData.value);
    }

    changeSelectStartDate = (pData) => {
        this.setState({ dateStart: pData });
        this.lookingForResults(pData, this.state.dateEnd, this.props.reportsReducerState.filterRouteReportProducts.value);
    }

    changeSelectEndDate = (pData) => {
        this.setState({ dateEnd: pData });
        this.lookingForResults(this.state.dateStart, pData, this.props.reportsReducerState.filterRouteReportProducts.value);
    }

    lookingForResults = (pDateStart, pDateEnd, pRoute) => {
        var filterRoute = '%';
        try {
            filterRoute = pRoute + '';
        } catch (__) { }
        if (filterRoute === '@') {
            filterRoute = '%'
        }
        if (filterRoute === '') {
            filterRoute = '0'
        }
        var info = {
            parameterString1: FrameWorkFormatDate(pDateStart, '-'),
            parameterString2: FrameWorkFormatDate(pDateEnd, '-'),
            parameterString3: filterRoute,
        }
        this.props.setMessageReportsRequested(1);
        this.props.requestGetReportDashboard(info);
    }

    processMessageState = (pStateForMessage) => {
        switch (pStateForMessage) {
            case 1://procesando solicitud
                FrameWorkSimpleMessageState(this, 'Recuperando información', 'Se está procesando ...');
                break;
            case 2:
                FrameWorkHideAlert(this);
                this.props.setMessageReportsRequested(0);
                break;
            case 3:
                var localMessageError = this.props.reportsReducerState.responseGetReportDashboard;
                FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
                console.error(localMessageError)
                break;
            default:
                FrameWorkHideAlert(this);
                this.props.setMessageReportsRequested(0);
                break;
        }
    }

    processForChart = (pData) => {
        const chartMostShippedProducts = {
            labelsForTable: [],
            data: {
                labels: [],
                datasets: [
                    {
                        label: '',
                        borderColor: '#6bd098',
                        pointRadius: 0,
                        pointHoverRadius: 0,
                        fill: false,
                        borderWidth: 3,
                        data: []
                    }
                ]
            },
            options: {
                legend: {
                    display: false
                },

                tooltips: {
                    enabled: false
                },

                scales: {
                    yAxes: [
                        {
                            ticks: {
                                fontColor: '#9f9f9f',
                                beginAtZero: false,
                                maxTicksLimit: 5
                                //padding: 20
                            },
                            gridLines: {
                                drawBorder: false,
                                zeroLineColor: 'transparent',
                                color: 'rgba(255,255,255,0.05)'
                            }
                        }
                    ],

                    xAxes: [
                        {
                            barPercentage: 1.6,
                            gridLines: {
                                drawBorder: false,
                                color: 'rgba(255,255,255,0.1)',
                                zeroLineColor: 'transparent',
                                display: false
                            },
                            ticks: {
                                padding: 20,
                                fontColor: '#9f9f9f'
                            }
                        }
                    ]
                }
            }
        };
        var pos=0;
        var length=pData.length;
        while(pos<length){
            var pProduct=pData[pos];
            var pIndexproduct=pos;
            var localCode = 'P' + (pIndexproduct + 1);
            chartMostShippedProducts.data.datasets[0].data.push(pProduct.quantity);
            chartMostShippedProducts.data.labels.push(localCode);

            chartMostShippedProducts.labelsForTable.push(localCode + ' ' + pProduct.productName + ' cantidad: ' + pProduct.quantity + ' (' + pProduct.measureName + ')');
            pos++;
        }
        /*pData.map((pProduct, pIndexproduct) => {
            var localCode = 'P' + (pIndexproduct + 1);
            chartMostShippedProducts.data.datasets[0].data.push(pProduct.quantity);
            chartMostShippedProducts.data.labels.push(localCode);

            chartMostShippedProducts.labelsForTable.push(localCode + ' ' + pProduct.productName + ' cantidad: ' + pProduct.quantity + ' (' + pProduct.measureName + ')');
        })*/
        return chartMostShippedProducts;
    }

    getRoutesForEditIntOrder = () => {
        var localRoutes = [];
        try {
            var localdata=this.props.routesReducerState.responseGetRoutes.result;
            var pos=0;
            var length=localdata.length;
            while(pos<length){
                var itemRoute=localdata[pos];
                if (itemRoute.active === 1) {
                    localRoutes.push(itemRoute);
                }
                pos++;
            }
            /*this.props.routesReducerState.responseGetRoutes.result.map((itemRoute) => {
                if (itemRoute.active == 1) {
                    localRoutes.push(itemRoute);
                }
            });*/
        } catch (__) { }
        var result = [{ value: '', label: '' }]
        result =
            (
                localRoutes.map((itemRoute, indexRoute) => {
                    return (
                        { value: itemRoute.id, label: itemRoute.name, isDisabled: itemRoute.active !== 1 }
                    )
                })
            );
        return [{ value: '@', label: 'Todos' }, { value: '', label: 'Sin Asignar' }].concat(result);
    }

    render() {
        var report = this.props.reportsReducerState.responseGetReportDashboard.result || {};
        var contentChart = this.processForChart(report.listDispatchedProducts || []) || [];
        return (
            <>
                <div className='content mt-5 mb-0'>
                    {this.state.alert}
                    <div className='framework-flexcontainer'>
                        <div>
                            <h4>{'Tablero'}</h4>
                        </div>
                        <div className='text-right framework-flex-rigth'>
                        </div>
                    </div>
                    <Card className=''>
                        <CardBody>
                            <Row className='framework-v-center'>
                                <Col xs='2'>
                                    <b>Inicio</b>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <ReactDatetime
                                            inputProps={{
                                                className: 'form-control',
                                                placeholder: 'Fecha inicial',
                                                readOnly: true
                                            }}
                                            defaultValue={this.props.reportsReducerState.dateReportsRequested}
                                            dateFormat='YYYY-MM-DD'
                                            onChange={(value) => { this.changeSelectStartDate(value) }}
                                            timeFormat={false}
                                            closeOnSelect={true}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className='framework-v-center'>
                                <Col xs='2'>
                                    <b>Fin</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                </Col>
                                <Col>
                                    <FormGroup>
                                        <ReactDatetime
                                            inputProps={{
                                                className: 'form-control',
                                                placeholder: 'Fecha final',
                                                readOnly: true
                                            }}
                                            defaultValue={this.props.reportsReducerState.dateReportsRequested}
                                            dateFormat='YYYY-MM-DD'
                                            onChange={(value) => { this.changeSelectEndDate(value) }}
                                            timeFormat={false}
                                            closeOnSelect={true}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className='framework-v-center'>
                                <Col xs='2'>
                                    <b>Ruta</b>
                                </Col>
                                <Col>
                                    <Select
                                        className='react-select'
                                        classNamePrefix='react-select'
                                        name='routeOrderRequested'
                                        placeholder='Seleccione la ruta'
                                        value={this.props.reportsReducerState.filterRouteReportProducts}
                                        options={
                                            this.getRoutesForEditIntOrder()
                                        }
                                        onChange={value => {
                                            this.changeSelectRouteFilter(value);
                                        }
                                        }
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Row>
                        <Col lg='4' md='6' sm='6'>
                            <Card className='card-stats'>
                                <CardBody>
                                    <Row>
                                        <Col md='4' xs='5'>
                                            <div className='icon-big text-center icon-warning'>
                                                <i className='nc-icon nc-cart-simple text-warning' />
                                            </div>
                                        </Col>
                                        <Col md='8' xs='7'>
                                            <div className='numbers'>
                                                <p className='card-category'>
                                                    {'Solicitudes registradas'}
                                                </p>
                                                <CardTitle tag='p'>
                                                    {report.requests || 0}
                                                </CardTitle>
                                                <p />
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                                <CardFooter>
                                    <hr />
                                    <div className='stats'>
                                        <Button color='warning' onClick={() => {
                                            //this.props.history.push('/admin/makeOrder') 
                                            OrdenExpressNavegatePath(this, 'makeOrder');
                                        }}>Ir a solicitud</Button>
                                    </div>
                                </CardFooter>
                            </Card>
                        </Col>


                        <Col lg='4' md='6' sm='6'>
                            <Card className='card-stats'>
                                <CardBody>
                                    <Row>
                                        <Col md='4' xs='5'>
                                            <div className='icon-big text-center icon-warning'>
                                                <i className='nc-icon nc-delivery-fast text-success' />
                                            </div>
                                        </Col>
                                        <Col md='8' xs='7'>
                                            <div className='numbers'>
                                                <p className='card-category'>Órdenes para despacho</p>
                                                <CardTitle tag='p'>
                                                    {report.dispatched || 0}
                                                </CardTitle>
                                                <p />
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                                <CardFooter>
                                    <hr />
                                    <div className='stats'>
                                        <Button color='success' onClick={() => {
                                            //this.props.history.push('/admin/processOrders') 
                                            OrdenExpressNavegatePath(this, 'processOrders');
                                        }}>Ir a órdenes</Button>
                                    </div>
                                </CardFooter>
                            </Card>
                        </Col>

                        <Col lg='4' md='6' sm='6'>
                            <Card className='card-stats'>
                                <CardBody>
                                    <Row>
                                        <Col md='4' xs='5'>
                                            <div className='icon-big text-center icon-warning'>
                                                <i className='nc-icon nc-bag-16 text-danger' />
                                            </div>
                                        </Col>
                                        <Col md='8' xs='7'>
                                            <div className='numbers'>
                                                <p className='card-category'>Órdenes para entrega</p>
                                                <CardTitle tag='p'>
                                                    {report.delivered || 0}
                                                </CardTitle>
                                                <p />
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                                <CardFooter>
                                    <hr />
                                    <div className='stats'>
                                        <Button color='danger' onClick={() => {
                                            //this.props.history.push('/admin/processOrders') 
                                            OrdenExpressNavegatePath(this, 'processOrders');
                                        }}>Ir a órdenes</Button>
                                    </div>
                                </CardFooter>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <CardHeader>
                                </CardHeader>
                                <CardBody>
                                    <h6 className='big-title'>
                                        Cantidades para despacho por producto
                                    </h6>
                                    <Bar
                                        data={contentChart.data}
                                        options={contentChart.options}
                                        height={380}
                                        width={826}
                                    />
                                </CardBody>
                                <CardFooter>
                                    <hr />
                                    <Row>
                                        <Col>
                                            {
                                                contentChart.labelsForTable.map((pContent, pIndexContent) => {
                                                    return (
                                                        <div
                                                            key={`divProduct${pIndexContent}`}
                                                            className={`footer-title ${pIndexContent % 2 === 0 ? 'bg-gray' : 'bg-white'}`}>
                                                            {pContent}
                                                        </div>
                                                    );
                                                })
                                            }
                                        </Col>
                                    </Row>
                                    <hr />
                                    <div className='stats'>
                                        <Button color='danger' onClick={() => {
                                            //this.props.history.push('/admin/products') 
                                            OrdenExpressNavegatePath(this, 'products');
                                        }}>Ir a productos</Button>
                                    </div>
                                </CardFooter>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        reportsReducerState: state.reportsReducerState,
        loginReducerState: state.loginReducerState,
        routesReducerState: state.routesReducerState,
    };
};

const mapDispatchToProps = dispatch => {
    return {

        setMessageReportsRequested: (messageReportsRequested) => dispatch(setMessageReportsRequested(messageReportsRequested)),
        setDateReportsRequested: (dateReportsRequested) => dispatch(setDateReportsRequested(dateReportsRequested)),
        setfFilterRouteReportProducts: (filterRouteReportProducts) => dispatch(setfFilterRouteReportProducts(filterRouteReportProducts)),

        requestGetRoutes: () => bindActionCreators(dispatch(requestGetRoutes()), dispatch),
        requestGetReportDashboard: (dataDateForReportDashboard) => bindActionCreators(dispatch(requestGetReportDashboard(dataDateForReportDashboard)), dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardOrdenExpress);
